<template>
  <v-speed-dial
    v-model="fab"
    top="top"
    right="right"
    direction="left"
    class="fab-help-dial"
    role="complementary"
    :aria-label="$t('student.help.help')"
    :title="$t('student.help.help')"
    fixed>
    <v-btn
      id="student-help-btn"
      aria-label="student-help"
      slot="activator"
      :style="{backgroundColor: helpButtonColour}"
      class="help-btn"
      v-model="fab"
      @click="helpClicked"
      role="button">
      <h3
        class="help-btn-txt"
        :style="{color: helpButtonTextColour}"
      >{{ $t('student.help.help') }}</h3>
    </v-btn>
    <v-dialog v-model="fab" content-class="help-dialog" max-width="450px" role="dialog">
      <v-flex xs12 >
        <h3 class="text-xs-center help-dialog-title">{{ $t('student.help.article_title') }}</h3>
        <fab-help-button v-for="article in buttons"
                         :key="article.identifier"
                         :article="article"
                         @close-help-popup="closeHelpPopup"/>
      </v-flex>
    </v-dialog>
  </v-speed-dial>
</template>

<script>
import FabHelpButton from './FabHelpButton'
import {POST_STUDENT_HELP_POPUP} from '../../../store/action-types'
import {SET_HELP_MENU_FLAG} from '../../../store/mutation-types'
import {mapActions, mapState} from 'vuex'

export default {
  components: {FabHelpButton},
  name: 'fab-dial',
  props: {
    buttons: {
      required: true,
      type: Array
    }
  },
  data () {
    return {}
  },
  methods: {
    ...mapActions({
      postHelpPopUp: POST_STUDENT_HELP_POPUP
    }),
    helpClicked () {
      if (!this.fab) {
        this.postHelpPopUp()
      }
    },
    closeHelpPopup () {
      this.$store.commit(SET_HELP_MENU_FLAG, false)
    }
  },
  computed: {
    ...mapState({
      helpButtonColour: state => state.config.helpButtonColour,
      roles: state => state.profile.roles,
      helpButtonTextColour: state => state.config.helpButtonTextColour
    }),
    fab: {
      get () {
        return this.$store.state.student.fab
      },
      set (value) {
        this.$store.commit(SET_HELP_MENU_FLAG, value)
      }
    }
  }
}
</script>

<style scoped>
.fab-help-dial {
  transition: all 0.3s ease-out;
  z-index: 4;
  right: 0px;
  top: 25%;
  -webkit-backface-visibility: hidden;
}

.help-dialog-title {
  color: white;
}

.help-btn {
  height: initial;
  margin: initial;
  min-height: 70px;
  min-width: 40px;
  width: 40px;
  padding: 5px 8px 5px 8px;
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2),
              0 12px 17px 2px rgba(0, 0, 0, .14),
              0 5px 22px 4px rgba(0, 0, 0, .12);
  text-transform: unset !important;
}

.help-btn-txt {
  writing-mode: vertical-rl;
  text-orientation: upright;
}
</style>
<style>
.help-dialog {
  box-shadow: none;
  overflow-y: visible;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/misc/fab/FabHelpDial.vue